import React from "react";
import "./LocalAds.css";
import { useState, useEffect } from "react";
import adsStyle from "./LocalBizAds.module.css";
import appURLs from "../../../appURL";
import getFetchConfig from "../../../utils/getFetchConfig";
import getSymbolFromCurrency from "currency-symbol-map";
import SimpleImageSlider from "react-simple-image-slider";
import FeaturedImage from "../../../assest/images/Group 1686553295.png";
import CommonModalWrapper from "../../common-modal-Wrapper/CommonModalWrapper";
import AdsPlans from "../../postAds/ads-plans/AdsPlans";
import CloseIcon from "../../Icons/CloseIcon";
import { toast } from "react-toastify";
import SocialMediaLink from "../../socialMediaLink/socialMediaLink";
import dotImage from "../../../assest/images/my_add_menu.svg";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import TransferModal from "../../Modals/TransferModal";
import "../MyAds.css"

function LocalBizAdsComp({
  item,
  index,
  transfer,
  featureStatus,
  getTimeSinceCreation,
  setcheckLocalBizEdit,
  status_detail,
  LocalBizAdsData,
  setLocalBizAdsData,
  setadsIds
}) {

  const fetchConfig = getFetchConfig(),
    appURL = appURLs();
  const navigate = useNavigate();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [showAdsPlan, setShowAdsPlan] = useState(false);
  const [showTransfer, setShowTransfer] = useState(false)
  const [myads_id, setmyads_id] = useState('');

  function stopRedirect(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function openModal() {
    setIsOpen(true);
  }


  function closeModal(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setIsOpen(false);
  }

  const titlebtn = (id) => {
    if (item.status !== 'draft') {
      navigate(`/localBizDetails/${id}`)
    }
  };

  const handleTransferClick = (id) => {
    setShowTransfer(true);
  };

  const closeTransferModal = (toggleValue = false, event) => {
    event.stopPropagation();
    setShowTransfer(toggleValue);
  };
  // const closeTransferModal = (toggleValue = false, event) => {
  //   if (event?.stopPropagation) event.stopPropagation();
  //   setShowTransfer(false);
  // };
  const handlePromoteClick = (id) => {
    // Set showAdsPlan to true to show the AdsPlan component
    setShowAdsPlan(true);
  };

  const closeThisModal = (toggleValue = false, event) => {
    event.stopPropagation();
    setShowAdsPlan(toggleValue);
  };

  function formatDate(dateString) {
    const options = { month: "2-digit", day: "2-digit", year: "numeric" };
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString(undefined, options);
    return formattedDate;
  }
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
    overlay: {
      background: `rgba(0, 0, 0, 0.4)`,
      zIndex: 1,
    },
  };

  const editFunctionality = (id, event) => {
    event.stopPropagation();
    setcheckLocalBizEdit((prevCheckJRentalEdit) => !prevCheckJRentalEdit);
    setIsOpen(false);
    setadsIds(id)
    localStorage.setItem("new_my_id", id);
  };

  const deleteFunctionality = async (event, id) => {
    event.stopPropagation();
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };
      const response = await fetch(`${appURL}/posts/biz/remove?ads_id=${id}`, {
        ...fetchConfig,
        method: "PATCH",
        headers: headers,
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const jsonData = await response.json();
      const data = LocalBizAdsData.filter((data) => data._id != id)
      setLocalBizAdsData(data)
      toast.success('Ads deleted Successfully')
      setIsOpen(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <div key={index} className="ad_details_wrap" onClick={() => { titlebtn(item._id) }}>

        <div className="ad_details_image_main">
          {Array.isArray(item.adsInfo?.image) && item.adsInfo.image.length > 0 ? (
            <img src={item.adsInfo.image[0].url} alt="Dummy" />
          ) : (
            <img src={FeaturedImage} alt="Dummy" />
          )}
          {item.status === "active" || item.status === 'draft' ? (
            <>
              <div style={{ width: "30px" }} className="dots_set"
                onClick={(e) => {
                  e.stopPropagation();
                  openModal();
                }
                }>
                <img src={dotImage} alt="" />
                <Modal
                  isOpen={modalIsOpen}
                  onRequestClose={closeModal}
                  style={customStyles}
                  contentLabel="Example Modal"
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* <div className={adsStyle.ads_mod}> */}
                  <div className={adsStyle.ads_mod} onClick={(e) => e.stopPropagation()}>
                    <button
                      className={adsStyle.close_button}
                      // onClick={closeModal}
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); closeModal(e); }}
                    >
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                    <div className={adsStyle.fav_pop_up}>
                      <ul>
                        <li
                          key={index}
                          onClick={(e) => editFunctionality(item._id, e)}
                        >
                          Edit
                        </li>
                        <li
                          key={index}
                          onClick={(e) => deleteFunctionality(e, item._id)}
                        >
                          Delete
                        </li>
                      </ul>
                    </div>
                  </div>
                </Modal>
              </div>
            </>
          ) : (
            ""
          )}
        </div>


        <div className="complete_div">
          <div className="title_set" onClick={stopRedirect}>
            {item.adsInfo.title && <h3>{item.adsInfo.title}</h3>}

            <button className={`button_status ${item.status}`}>
              {item.status === 'inactive' ? 'expired' : item.status}
            </button>
          </div>

          <div className="den_div">
            {item.adsInfo.descriptions && <p>{item.adsInfo.descriptions}</p>}

            {item.adsInfo.location.location_name && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="fa-solid fa-location-dot"></i> &nbsp;
                <p>{item.adsInfo.location.location_name}</p>
              </div>
            )}
          </div>

          {item.adsInfo.image && <img src="/src/assets/image 6 (2).png" alt="" />}

          {item.status === 'active' ?
            <div className="text_div">
              {/* show price logic */}

              <div className="text_right">
                <div className="urgent_label">
                  {item.addons_validity.some(
                    (addon) => addon.name === "Urgent" && new Date(addon.expired_on) >= new Date()
                  ) && <button>Urgent</button>}
                </div>

                <div className="upcoming_label">
                  {item.addons_validity.some(
                    (addon) => addon.name === "Upcoming event"
                  ) && <button>Upcoming event</button>}
                </div>
              </div>
            </div>
            : ""}


          <div className="listed_by">
            {item.status !== 'draft' && (
              <p>
                Listed on:{" "}
                <span style={{ fontSize: "13px" }}>
                  {getTimeSinceCreation(
                    item.active_on_virtual,
                    item.location_timezone
                  )}
                </span>
              </p>
            )}

            {item.status === 'draft' && (
              <p>
                Listed on:{" "}
                <span style={{ fontSize: "13px" }}>
                  {getTimeSinceCreation(item.createdAt)}
                </span>
              </p>
            )}

            <p >
              {item.status === "active" || item.status === "draft" ? (
                <>
                  Active until:{"  "}
                  <span style={{ fontSize: "13px" }}>
                    {item.plan_validity && item.plan_validity.expired_on !== 'lifetime'
                      ? formatDate(item.plan_validity.expired_on)
                      : <span style={{ color: 'green', margin: '0px' }}>Lifetime</span>}
                  </span>
                </>
              ) : item.status === "deleted" ? (
                <>
                  Ad deleted date:{" "}
                  <span style={{ fontSize: "13px" }}>
                    {item.deletedAt ? formatDate(item.deletedAt) : ""}
                  </span>
                </>
              ) : item.status === "inactive" ? (
                <>
                  Ad expired date:{" "}
                  <span style={{ fontSize: "13px" }}>
                    {item.plan_validity && item.plan_validity.expired_on
                      ? formatDate(item.plan_validity.expired_on)
                      : "No expiration date"}
                  </span>
                </>
              ) : null}
            </p>


          </div>
        </div>

        <div className="view_counts_promo">
          <div className="view_counts">
            <div className="heart_count">
              <svg
                width="23"
                height="21"
                viewBox="0 0 23 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.6066 4.13581C9.60726 1.7984 6.27321 1.16964 3.76816 3.31001C1.26311 5.45038 0.910432 9.02898 2.87766 11.5604C4.51328 13.6651 9.46324 18.1041 11.0856 19.5408C11.2671 19.7016 11.3578 19.7819 11.4637 19.8135C11.5561 19.8411 11.6572 19.8411 11.7496 19.8135C11.8554 19.7819 11.9462 19.7016 12.1277 19.5408C13.75 18.1041 18.6999 13.6651 20.3356 11.5604C22.3028 9.02898 21.9932 5.42787 19.4451 3.31001C16.897 1.19216 13.606 1.7984 11.6066 4.13581Z"
                  stroke="#A9A8B3"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              {item.favoriteCount}
            </div>

            <div className="heart_count">
              <svg
                width="25"
                height="18"
                viewBox="0 0 25 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.3064 7.90968C23.8506 8.62284 23.8506 9.58561 23.3064 10.2976C21.5921 12.5395 17.4793 17.1555 12.6775 17.1555C7.87577 17.1555 3.76293 12.5395 2.04867 10.2976C1.78388 9.95615 1.64014 9.53606 1.64014 9.10365C1.64014 8.67125 1.78388 8.25116 2.04867 7.90968C3.76293 5.66782 7.87577 1.05182 12.6775 1.05182C17.4793 1.05182 21.5921 5.66782 23.3064 7.90968V7.90968Z"
                  stroke="#C9C9C9"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.6776 12.5544C14.58 12.5544 16.1222 11.0094 16.1222 9.10362C16.1222 7.1978 14.58 5.65283 12.6776 5.65283C10.7752 5.65283 9.23297 7.1978 9.23297 9.10362C9.23297 11.0094 10.7752 12.5544 12.6776 12.5544Z"
                  stroke="#C9C9C9"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              {item.viewCount ? item.viewCount : ""}
            </div>
          </div>

          <div className="promotion">

            {item.status === 'deleted' || item.status === 'inactive' ?
              <div
                key={index}
                // onClick={(event) => {
                //   editFunctionality(item._id);
                //   stopRedirect(event);
                // }}
                onClick={(event) => {
                  event.stopPropagation();
                  editFunctionality(item._id, event);
                }}
              >
                <button className="respost_btn">Repost</button>
              </div>
              :
              ""
            }

            <div className="d-flex gap-2">
              {transfer && (
                <button
                  className="transfer_btn"
                  key={index}
                  onClick={(event) => {
                    stopRedirect(event);
                    handleTransferClick(item._id);
                  }}
                >
                  Transfer
                </button>
              )}
              {item.status === "active" && (
                <button
                  className="respost_btn"
                  key={index}
                  onClick={(event) => {
                    stopRedirect(event);
                    handlePromoteClick(item._id);
                  }}
                >
                  Promote
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      {showAdsPlan && (
        <CommonModalWrapper
          isOpen={true}
          className="room_rents_modal_wrapper"
        >
          <CloseIcon onClick={(event) => closeThisModal(false, event)} />
          <AdsPlans
            adsId={item._id}
            adsCategoriesId={item.adsType}
            category={"biz"}
            myads_id={myads_id}
            showAdsPlan={showAdsPlan}
            setShowAdsPlan={setShowAdsPlan}
          />
        </CommonModalWrapper>
      )}

      {showTransfer && (
        <CommonModalWrapper
          isOpen={true}
          className="room_rents_modal_wrapper"
        >
          <CloseIcon onClick={(event) => closeTransferModal(false, event)} />
          <TransferModal
            adsId={item._id}
          />
        </CommonModalWrapper>
      )}

    </>
  );
}

export default LocalBizAdsComp;
